import apiClient from '../config/api';

const skuService = {
  /**
   * Get all SKUs for the current tenant
   */
  getAllSkus: async () => {
    const response = await apiClient.get('/productsku');
    return response.data;
  },

  /**
   * Get SKUs for a specific product
   * @param {number} productId
   */
  getSkusByProduct: async (productId) => {
    const response = await apiClient.get(`/productsku/product/${productId}`);
    return response.data;
  },

  /**
   * Get active SKUs for a specific product
   * @param {number} productId
   */
  getActiveSkusByProduct: async (productId) => {
    const response = await apiClient.get(`/productsku/product/${productId}/active`);
    return response.data;
  },
};

export default skuService;
